










































import { handleErrorMessageToast } from '@/common/util';
import InputText from '@/components/input/text.vue';
import ProgressStep from '@/components/progress-step/index.vue';
import {
    computed,
    defineComponent,
    onMounted,
    reactive,
    ref,
    toRefs,
} from '@vue/composition-api';
import { useApolloModel } from 'vue-apollo-model';
import {
    SignContractProgressDetail,
    SignContractStepsText,
} from '../../../const';
import BackToPrevious from '../../back-to-pre.vue';
import LoadingStatus from '../finance/loading-status.vue';
import { ContractSignUrlSubmit, GameContractModel } from './model';
import SignInfoPage from './sign-info-page.vue';
import SignPage from './sign-page.vue';

export default defineComponent({
    name: 'contract-sign',
    components: {
        InputText,
        BackToPrevious,
        ProgressStep,
        LoadingStatus,
        SignInfoPage,
        SignPage,
    },
    setup(props, context) {
        const model = useApolloModel(GameContractModel);
        const state = reactive({
            stepActive: -1,
            isShowNoUse: false, // 不知道起啥名，代表9个没用的交互loading过程显示
            signFailed: false,
            finished: new Set<Number>(),
            statusBtnCb: () => {},
            companyRegisteredAddress: '',
            companyMailingAddress: '',
            invoiceContentType: 0,
            invoiceType: 0,
            iapInvoiceContentType: 0,
            iapInvoiceType: 0,
        });
        const invoice = computed(() => {
            return {
                companyRegisteredAddress: state.companyRegisteredAddress,
                companyMailingAddress: state.companyMailingAddress,
                invoiceContentType: state.invoiceContentType,
                invoiceType: state.invoiceType,
            };
        });
        const progressStatus = ref({
            title: '',
            desc: '',
            type: '',
            btnMsg: '',
        });
        function goDetail() {
            context.root.$router.push({
                name: 'gameDetail',
                params: {
                    appId: context.root.$route.params.appId!,
                },
                query: {
                    activeTab: 'eighth',
                },
            });
        }
        // @ts-ignore
        async function handleUpdateInfo(params: any) {
            // addresses: Array<string>, invoice: Array<number>, canSubmit: boolean, iapInvoice: Array<number>, gameType: string
            const { addresses, invoice, canSubmit, iapInvoice, realizationWay } = params;
            if (
                document.querySelectorAll('div.show-text-tip-error').length >
                    0 ||
                !canSubmit
            ) {
                handleErrorMessageToast('请按照提示输入完整后提交');
                return;
            }

            if(realizationWay === 'iaa') {
                state.invoiceContentType = invoice[0];
                state.invoiceType = invoice[1];
                state.iapInvoiceContentType = 0;
                state.iapInvoiceType = 0;
            } else if(realizationWay === 'iap') {
                state.invoiceContentType = 0;
                state.invoiceType = 0;
                state.iapInvoiceContentType = iapInvoice[0];
                state.iapInvoiceType = iapInvoice[1];
            } else if(realizationWay === 'iaap') {
                state.invoiceContentType = invoice[0];
                state.invoiceType = invoice[1];
                state.iapInvoiceContentType = iapInvoice[0];
                state.iapInvoiceType = iapInvoice[1];
            }
            state.companyRegisteredAddress = addresses[0];
            state.companyMailingAddress = addresses[1];
            state.stepActive = 1;
        }

        async function handleStartSign() {
            const signInfo = {} as ContractSignUrlSubmit;
            signInfo.appId = context.root.$route.params.appId;
            if (context.root.$route.query.renewContract === 'true') {
                if (context.root.$route.query.contractNo) {
                    signInfo.originalContractNo = context.root.$route.query
                        .contractNo as string;
                } else if (
                    model.contractDetailInfo.contractInfo?.contractNo?.length > 0
                ) {
                    signInfo.originalContractNo =
                        model.contractDetailInfo.contractInfo?.contractNo;
                }
            }
            if (context.root.$route.query.from === 'auth') {
                signInfo.returnUrl = `${location.href}`;
            } else if (Object.keys(context.root.$route.query).length !== 0) {
                signInfo.returnUrl = `${location.href}&from=auth`;
            } else {
                signInfo.returnUrl = `${location.href}?from=auth`;
            }
            signInfo.companyRegisteredAddress = state.companyRegisteredAddress;
            signInfo.companyMailingAddress = state.companyMailingAddress;
            signInfo.invoiceContentType = state.invoiceContentType;
            signInfo.invoiceType = state.invoiceType;
            signInfo.iapInvoiceContentType = state.iapInvoiceContentType;
            signInfo.iapInvoiceType = state.iapInvoiceType;

            progressStatus.value = SignContractProgressDetail.signWaiting;
            state.isShowNoUse = true;
            await model.contractSignUrlMut(signInfo);
            if (model.contractSignUrl.signUrl?.length > 0) {
                window.location.href = model.contractSignUrl.signUrl.toString();
            } else if (model.contractSignUrlMutation.data.result !== 1) {
                state.isShowNoUse = false;
                handleErrorMessageToast(
                    model.contractSignUrlMutation.data.error_msg,
                );
            }
        }

        function handlePreviousStep() {
            state.stepActive = 0;
        }

        function signSuccess() {
            state.signFailed = false;
            progressStatus.value = SignContractProgressDetail.signSuccess;
            progressStatus.value.title = `您的${model.contractSignStatus.gameName}游戏的合同签署成功，已同步为您开通自助结算功能。`;
            state.statusBtnCb = () => {
                state.stepActive = 2;
                state.isShowNoUse = false;
                goDetail();
            };
            // setTimeout(() => {
            //     state.stepActive = 2;
            //     state.isShowNoUse = false;
            //     goDetail();
            // }, 3000);
        }

        async function getSignAuth() {
            state.isShowNoUse = true;
            await model.contractSignStatusMut({
                appId: context.root.$route.params.appId,
            });
            if (model.contractSignStatus.contractStatus === 2) {
                signSuccess();
            } else if(model.contractSignStatus.contractStatus === 0) {
                progressStatus.value = SignContractProgressDetail.signLoad;
                state.statusBtnCb = () => {
                    getSignAuth();
                };
            } else {
                state.signFailed = true;
                progressStatus.value = SignContractProgressDetail.signError;
                progressStatus.value.desc = model.contractSignStatusMutation.data.error_msg;
                state.statusBtnCb = () => {
                    goDetail();
                };
            }
        }

        onMounted(async () => {
            await model.getAuth({
                appId: context.root.$route.params.appId,
            });
            if (model.pageStatus.changePhone || model.pageStatus.changeAdmin) {
                goDetail();
                return;
            }

            state.isShowNoUse = false;
            if (context.root.$route.query.from === 'auth') {
                getSignAuth();
                return;
            }
            state.stepActive = 0;
        });
        return {
            model,
            invoice,
            SignContractStepsText,
            progressStatus,
            ...toRefs(state),
            handleUpdateInfo,
            handlePreviousStep,
            handleStartSign,
        };
    },
});
